import type { Breadcrumb } from "~/core/models/Breadcrumb.interface";
import { PATH_ABOUT } from "~/modules/about/constants";
import { PATH_PARAMETERS_APPLICATIONS } from "~/modules/applicationManagement/constants";
import { PATH_CAMPAIGNS } from "~/modules/campaign/constants";
import { PATH_DTWINS } from "~/modules/dtwin/constants";
import { PATH_PARAMETERS_FIRMWARES } from "~/modules/firmware/constants";
import { PATH_FLEETS } from "~/modules/fleet/constants";
import { PATH_PARAMETERS_GLOBAL_DEVICE_CONFIGURATION } from "~/modules/globalDeviceConfiguration/constants";
import { PATH_LOGS } from "~/modules/log/constants";
import { PATH_SECTORS } from "~/modules/sector/constants";
import {
  PATH_USER_ACCOUNT,
  PATH_USER_MANAGEMENT,
  PATH_USER_MANAGEMENT_GROUPS,
  PATH_USER_MANAGEMENT_PROFILES,
} from "~/modules/user/constants";
import ILxCampaign from "~icons/lxc-business/campaign";
import ILxcHomeLine from "~icons/lxc-custom/home-line";
import ILxcInfoFilledItalic from "~icons/lxc-custom/info-filled-italic";
import ILxcCompass from "~icons/lxc/compass";
import ILxcMapPin from "~icons/lxc/map-pin";
import ILxcSettings from "~icons/lxc/settings";
import ILxcTablet from "~icons/lxc/tablet";
import ILxcUser from "~icons/lxc/user";

export const BREADCRUMBS: Record<string, Breadcrumb> = {
  SECTOR: {
    title: "page.sectors.title",
    disabled: false,
    href: PATH_SECTORS,
    icon: ILxcMapPin,
  },
  DTWIN: {
    title: "page.dtwins.title",
    disabled: false,
    href: PATH_DTWINS,
    icon: ILxcTablet,
  },
  CAMPAIGN: {
    title: "page.campaigns.title",
    disabled: false,
    href: PATH_CAMPAIGNS,
    icon: ILxCampaign,
  },
  DASHBOARD: {
    title: "page.dashboard.title",
    disabled: false,
    href: "/",
    icon: ILxcHomeLine,
  },
  PROFILE: {
    title: "page.profiles.title",
    disabled: false,
    href: PATH_USER_MANAGEMENT_PROFILES,
    icon: ILxcUser,
  },
  GROUP: {
    title: "page.userGroups.title",
    disabled: false,
    href: PATH_USER_MANAGEMENT_GROUPS,
    icon: ILxcUser,
  },
  LOGS: {
    title: "page.logs.title",
    disabled: false,
    href: PATH_LOGS,
    icon: ILxcCompass,
  },
  PARAMETERS: {
    title: "page.parameters.title",
    disabled: false,
    href: "",
    icon: ILxcSettings,
  },
  FIRMWARE: {
    title: "page.firmware.title",
    disabled: false,
    href: PATH_PARAMETERS_FIRMWARES,
  },
  USER_MANAGEMENT: {
    title: "page.users.title",
    disabled: false,
    href: PATH_USER_MANAGEMENT,
    icon: ILxcUser,
  },
  APPLICATION_MGT: {
    title: "page.applicationMgts.title",
    disabled: false,
    href: PATH_PARAMETERS_APPLICATIONS,
  },
  USER_ACCOUNT: {
    title: "page.userAccount.title",
    disabled: false,
    href: PATH_USER_ACCOUNT,
    icon: ILxcUser,
  },
  ABOUT: {
    title: "page.about.title",
    disabled: false,
    href: PATH_ABOUT,
    icon: ILxcInfoFilledItalic,
  },
  FLEETS: {
    title: "page.fleets.title",
    disabled: false,
    href: PATH_FLEETS,
    icon: ILxcTablet,
  },
  GLOBAL_DEVICE_CONFIGURATION: {
    title: "page.deviceConfiguration.title",
    disabled: false,
    href: PATH_PARAMETERS_GLOBAL_DEVICE_CONFIGURATION,
  },
};
